<!-- @format -->
<template>
  <div class="order-review-wrapper">
    <!-- 弹框模式 -->
    <el-dialog
      v-if="type !== 0"
      :title="title"
      :visible.sync="show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeDialog"
      width="1000px"
    >
      <div class="dialog-content lg">
        <div class="title">订单信息</div>
        <span>订单编号：</span><el-input
            v-model="form.orderNo"
            placeholder=""
            style="width: 300px; margin-right: 20px"
            size="small"
            :disabled="true"
        />

        <span>订单状态：</span><el-input
            v-model="form.statusName"
            style="width: 150px; margin-right: 20px"
            size="small"
            :disabled="true"
        />

        <span>下单时间：</span><el-date-picker
            size="small"
            style="width: 180px; margin-right: 20px"
            v-model="form.createTime"
            :disabled="true"
            type="date">
        </el-date-picker>


        <div class="title">产品信息</div>
        <el-table
                :cell-style="{color:'#000000',fontSize: '15px' }"
                :header-cell-style="{color:'#000000',fontSize: '15px' }"
                :data="data1"
                :border="true"
                :highlight-current-row="true"
                stripe
                row-key="id"
                style="width: 100%;"
            >
            <el-table-column align="center" prop="cpmc" label="产品名称" />
            <el-table-column align="center"  prop="dkedxx" label="贷款额度">
              <template slot-scope="scope">
                  <span>{{ scope.row.dkedxx +' ~ '+ scope.row.dkedsx + '万元'}}</span>
                </template>
              </el-table-column>
            <el-table-column  align="center" prop="dkqxxx" label="贷款期限">
              <template slot-scope="scope">
                <span>{{ scope.row.dkqxxx +' ~ '+ scope.row.dkqxsx + '月'}}</span>
              </template>
            </el-table-column>
            <el-table-column  align="center" prop="zdnhlv" label="年化利率">
              <template slot-scope="scope">
                <span>{{ scope.row.zdnhlv+'%' +' ~ '+ scope.row.zgnhlv + '%'}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="dbfsm" label="担保方式"  />
            <el-table-column align="center" prop="dklxm" label="贷款类型"  />
            <el-table-column align="center" prop="khjl" label="联系人及联系方式">
              <template slot-scope="scope">
                <span>{{ scope.row.khjl +' '+ scope.row.lxrdh}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="jrjgmg" label="所属机构"  />
        </el-table>


        <div class="title" v-if="(type==2) || (type==3)|| (type==4)">企业融资需求</div>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="dialogForm"
            label-width="120px"
            label-suffix="："
            style="padding: 20px 0 0 0;"
        >
            <el-form-item label="申请企业" prop="qymc" v-if="(type==2) || (type==3)|| (type==4)">
                <el-input
                    style="width: 260px"
                    v-model="form.qymc"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    size="small"
                    :disabled="true"
                />
            </el-form-item>
            <el-form-item label="贷款额度(万元)" prop="dked" v-if="(type==2) || (type==3)|| (type==4)">
                <el-input
                    style="width: 260px"
                    v-model="form.dked"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    size="small"
                    :disabled="(type==3)||(type==4)"
                    @input="val => form.dked = filterNumber(val)"
                />
            </el-form-item>
            <el-form-item label="年化利率(%)" prop="nhlv" v-if="(type==2) || (type==3)|| (type==4)">
                <el-input
                style="width: 260px"
                    v-model="form.nhlv"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    size="small"
                    :disabled="(type==3)||(type==4)"
                    @input="val => form.nhlv = filterNumber(val)"
                />
            </el-form-item>
            <el-form-item label="贷款期限(月)" prop="dkqx" v-if="(type==2) || (type==3)|| (type==4)">
                <el-input
                  style="width: 260px"
                    v-model="form.dkqx"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    size="small"
                    :disabled="(type==3)||(type==4)"
                    @input="val => form.dkqx = filterNumber(val)"
                />
            </el-form-item>
            <el-form-item label="担保方式" prop="dbfsc" v-if="(type==2) || (type==3)|| (type==4)" >
              <select-from-dictionary
                :code="'guaranty'"
                :placeholder="'担保方式'"
                :default-val="form.dbfsc"
                :disabled="((type==2)||(type==3))||(type==4)"
                size="small"
                :cus-style="'width: 260px; margin-right: 10px;'"
                @change="changeGuaranty"
              />
            </el-form-item>
            <el-form-item label="信贷类型" prop="dklxc" v-if="(type==2) || (type==3)|| (type==4)">
              <select-from-dictionary
                :code="'loan'"
                :placeholder="'信贷类型'"
                :disabled="((type==2)||(type==3))||(type==4)"
                :default-val="form.dklxc"
                size="small"
                :cus-style="'width: 260px; margin-right: 10px;'"
                @change="changeLoan"
              />
            </el-form-item>
            <el-form-item label="联系人" prop="khjl" v-if="(type==2) || (type==3)|| (type==4)">
                <el-input
                    style="width: 260px"
                    v-model="form.khjl"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    size="small"
                    :disabled="true"
                />
            </el-form-item>
            <el-form-item label="联系方式" prop="lxrdh" v-if="(type==2) || (type==3)||(type==4)">
                <el-input
                   style="width: 260px"
                    v-model="form.lxrdh"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    size="small"
                    :disabled="true"
                />
            </el-form-item>
            <el-form-item label="审核意见" prop="suggest" v-if="(type==1)">
                <el-input
                    style="width: 460px"
                    v-model="form.suggest"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    clearable
                    maxlength="300"
                    show-word-limit
                    size="small"
                    />
            </el-form-item>
            <el-form-item label="意见" prop="creditSuggest" v-if="(type==2)">
                <el-input
                    style="width: 460px"
                    v-model="form.creditSuggest"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    clearable
                    maxlength="300"
                    show-word-limit
                    size="small"
                    />
            </el-form-item>
            <el-form-item label="上传合同" prop="busFiles" v-if="(type==3)">
              <el-upload
                class="upload-demo"
                ref="upload"
                action="#"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-change="uploadedFiles"
                :file-list="form.busFiles"
                :auto-upload="false">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="查看合同" prop="busFiles" v-if="(type==4)">
              <el-upload
                style="width: 460px"
                class="upload-demo"
                ref="upload"
                action="#"
                :on-preview="handlePreview"
                :file-list="form.busFiles"
                :auto-upload="true"
                :disabled="true"
                >
              </el-upload>
            </el-form-item>
            <el-form-item label="意见" prop="yhFinishSuggest" v-if="(type==3)">
              <el-input
                  style="width: 460px"
                  v-model="form.yhFinishSuggest"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  clearable
                  maxlength="300"
                  show-word-limit
                  size="small"
                  />
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer" v-if="(type==1)">
          <el-button size="small" type="primary" @click="examineSubmit(2)">审核不通过</el-button>
          <el-button size="small" type="primary" @click="examineSubmit(3)">审核通过</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-if="(type==2)">
          <el-button size="small" type="primary" @click="creditSubmit(5)">审核不通过</el-button>
          <el-button size="small" type="primary" @click="creditSubmit(4)">审核通过</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-if="(type==3)">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" @click="contractSubmit">确认</el-button>
        </div>
        <!-- <div slot="footer" class="dialog-footer" v-if="(type==4)">
          <el-button size="small" @click="closeDialog">关闭</el-button>
        </div> -->
      </div>
    </el-dialog>

    <!-- 内联详情模式 (type==0) -->
    <div v-else class="detail-page">
      <div class="back-btn" @click="closeDialog">
        <i class="el-icon-arrow-left"></i> 返回
      </div>

      <!-- 订单信息 -->
      <div class="detail-card">
        <div class="card-title">
          <span class="title-bar"></span>
          订单信息
        </div>
        <div class="info-grid info-grid-3">
          <div class="info-row">
            <span class="info-label">订单编号</span>
            <span class="info-value">{{ form.orderNo }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">订单状态</span>
            <span class="info-value">{{ form.statusName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">下单时间</span>
            <span class="info-value">{{ form.createTime | formatTime }}</span>
          </div>
        </div>
      </div>

      <!-- 产品信息 -->
      <div class="detail-card">
        <div class="card-title">
          <span class="title-bar"></span>
          产品信息
        </div>
        <div class="info-grid info-grid-3">
          <div class="info-row">
            <span class="info-label">产品名称</span>
            <span class="info-value">{{ form.cpmc }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">贷款额度</span>
            <span class="info-value">{{ form.dkedxx }}～{{ form.dkedsx }}万元</span>
          </div>
          <div class="info-row">
            <span class="info-label">贷款期限</span>
            <span class="info-value">{{ form.dkqxxx }}～{{ form.dkqxsx }}月</span>
          </div>
          <div class="info-row">
            <span class="info-label">年化利率</span>
            <span class="info-value">{{ form.zdnhlv }}%～{{ form.zgnhlv }}%</span>
          </div>
          <div class="info-row">
            <span class="info-label">担保方式</span>
            <span class="info-value">{{ form.dbfsm }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">贷款类型</span>
            <span class="info-value">{{ form.dklxm }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">联系人</span>
            <span class="info-value">{{ form.khjl }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">联系方式</span>
            <span class="info-value">{{ form.lxrdh }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">所属机构</span>
            <span class="info-value">{{ form.jrjgmg }}</span>
          </div>
        </div>
      </div>

      <!-- 进度条 -->
      <div class="progress-card">
        <div class="progress-steps">
          <div
            v-for="(step, idx) in progressSteps"
            :key="idx"
            class="progress-step"
          >
            <div class="step-line-wrapper">
              <div
                class="step-dot"
                :class="{
                  done: form.status >= step.status,
                  current: form.status === step.status,
                }"
              >
                <i v-if="form.status >= step.status" class="el-icon-check"></i>
              </div>
              <div
                v-if="idx < progressSteps.length - 1"
                class="step-line"
                :class="{ done: form.status > step.status }"
              ></div>
            </div>
            <div
              class="step-label"
              :class="{
                done: form.status >= step.status,
                current: form.status === step.status,
              }"
            >
              {{ step.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- 申请信息 -->
      <div class="detail-card">
        <div class="card-title">
          <span class="title-bar"></span>
          申请信息
        </div>
        <el-descriptions :column="3" border>
          <el-descriptions-item label="申请企业">{{ form.qymc }}</el-descriptions-item>
          <!-- <el-descriptions-item label="贷款额度(万元)">{{ form.dked }}</el-descriptions-item>
          <el-descriptions-item label="贷款期限(月)">{{ form.dkqx }}</el-descriptions-item> -->
          <el-descriptions-item label="担保方式">{{ form.dbfsm }}</el-descriptions-item>
          <el-descriptions-item label="信贷类型">{{ form.dklxm }}</el-descriptions-item>
          <el-descriptions-item label="贷款类型">{{ form.dklxm }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{ form.khjl }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ form.lxrdh }}</el-descriptions-item>
          <el-descriptions-item label="金融机构审核意见" :span="3">
            {{ form.suggest || form.creditSuggest || '-' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
  </div>
</template>
  
<script>
import { uploadFiles } from '@/api/index'
import {financialExamine , financialCredit , financialContract , getDetails } from "@/views/financInstitutionPC/viewApi";
import { validateForm ,validateCellPhone } from '@/utils'

export default {
  props: ['show', 'title', 'viewData','type'],
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      data1:[],
      form:{
        busFiles:[],
        creditSuggest:''
      },
      rules: {
        busFiles: [
              { required: true, message: '请上传合同', trigger: ['blur', 'change'] }
          ],
        // 授信(type==2)时贷款额度、年化利率、贷款期限必填，且只能为数字
        dked: [
          { required: this.type == 2, message: '请输入贷款额度', trigger: ['blur', 'change'] },
          { pattern: /^\d+(\.\d+)?$/, message: '只能输入数字', trigger: ['blur', 'change'] }
        ],
        nhlv: [
          { required: this.type == 2, message: '请输入年化利率', trigger: ['blur', 'change'] },
          { pattern: /^\d+(\.\d+)?$/, message: '只能输入数字', trigger: ['blur', 'change'] }
        ],
        dkqx: [
          { required: this.type == 2, message: '请输入贷款期限', trigger: ['blur', 'change'] },
          { pattern: /^\d+(\.\d+)?$/, message: '只能输入数字', trigger: ['blur', 'change'] }
        ],
      },
      progressSteps: [
        { label: '开始', status: 1 },
        { label: '待审核', status: 1 },
        { label: '授信中', status: 3 },
        { label: '授信待确认', status: 4 },
        { label: '撮合成功', status: 6 },
        { label: '已成交', status: 8 },
      ],
    }
  },
  created() {
    if(this.viewData && this.viewData.id){
      this.form = {
        ...this.viewData,
        busFiles: this.viewData.busFiles ? this.viewData.busFiles :[],
      };
      if( this.viewData.status==1 ){
        this.form['statusName'] = "待审核";
      }else if( this.viewData.status==2 ){
        this.form['statusName'] = "审核不通过";
      }else if( this.viewData.status==3 ){
        this.form['statusName'] = "授信中";
      }else if( this.viewData.status==4 ){
        this.form['statusName'] = "授信待确认";
      }else if( this.viewData.status==5 ){
        this.form['statusName'] = "金融机构授信不通过";
      }else if( this.viewData.status==6 ){
        this.form['statusName'] = "撮合成功";
      }else if( this.viewData.status==7 ){
        this.form['statusName'] = "企业不同意授信";
      }else if( this.viewData.status==8 ){
        this.form['statusName'] = "已完成";
      }
      this.data1 = [this.form];

      getDetails({id:this.viewData.id}).then((res)=>{
        let busFiles = res.data.busFiles&&res.data.busFiles.map((item)=> {
          return { name: item.title , ...item }
        })
        this.form = {
          ...this.form,
          busFiles: busFiles ? busFiles :[],
        };
      })
      
    }
  },
  methods: {

    // 审核
    examineSubmit(type){
      financialExamine({
        id: this.form.id,
        status: type,
        suggest: this.form.suggest,
      }).then((res)=>{
        let message='';
        if(type==2){
          message = '已拒绝。'
        }else if(type==3){
          message = '审核通过。'
        }
        this.$baseMessage(message, 'success');
        this.$emit('closeDialog', true);
      })
    },
      
    //授信
    creditSubmit(type){
      // 授信通过时校验贷款额度、年化利率、贷款期限必填且只能为数字
      if (type == 4 && !validateForm(this.$refs['form'])) {
        this.$baseMessage('请正确填写贷款额度、年化利率、贷款期限。', 'error');
        return;
      }
      financialCredit({
        id: this.form.id,
        status: type,
        creditSuggest: this.form.creditSuggest,
        dked: this.form.dked,
        nhlv: this.form.nhlv,
        dkqx: this.form.dkqx,
      }).then((res)=>{
        let message='';
        if(type==2){
          message = '已拒绝。'
        }else if(type==3){
          message = '授信通过。'
        }
        this.$baseMessage(message, 'success');
        this.$emit('closeDialog', true);
      })
    },

    //上传合同
    contractSubmit(){
      if (!validateForm(this.$refs["form"])) {
        this.$baseMessage("表单信息缺失。", "error");
        return;
      }

      financialContract({
        id: this.form.id,
        yhFinishSuggest: this.form.yhFinishSuggest,
        busFiles: this.form.busFiles,
      }).then((res)=>{
        this.$baseMessage('上传成功。', 'success');
        this.$emit('closeDialog', true);
      })
    },

    changeGuaranty(data){
      this.form.dbfsc = data.code;
      this.form.dbfsm = data.dictionaryKey;
    },
    // 仅保留数字和小数点（小数点只保留第一个）
    filterNumber(val) {
      let v = String(val == null ? '' : val).replace(/[^\d.]/g, '');
      const i = v.indexOf('.');
      if (i !== -1) {
        v = v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, '');
      }
      return v;
    },
    changeLoan(data){
      this.form.dklxc = data.code;
      this.form.dklxm = data.dictionaryKey;
    },

    //上传
    uploadedFiles (file) {
      let formData = new FormData();
      formData.append('file', file.raw)  
      uploadFiles(formData).then(( res )=>{
        if(res.data){
          this.form.busFiles.push({
            title: res.data.fileName,
            url: res.data.url
          })
        }
      })
    },
    handleRemove(file, fileList) {
      this.form.busFiles = fileList.map((item)=>{
        return {
          title: item.title,
          url: item.url
        }
      })
    },
    handlePreview(file){
      var a = document.createElement('a');
      a.target = '_blank';
      a.download = file.name;
      console.log(this.baseUrl , file.url)
      a.href = this.baseUrl + file.url;
      document.body.appendChild(a) 
      a.click()
      a.remove()
    },

    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.title{
    font-weight: 800;
    height: 35px;
    width: 100%;
    font-size: 16px;
    line-height: 35px;
    border-bottom: 1px solid #dfdfdf;
    margin: 15px 0;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 40px;
  padding: 10px 0 0 0;

  // 按钮圆润化与间距优化
  ::v-deep .el-button {
    min-width: 110px;
    border-radius: 20px;
    padding: 9px 20px;
    font-size: 14px;
    font-weight: 500;
    justify-content: center;
    white-space: nowrap;
    transition: all 0.25s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(19, 102, 236, 0.25);
    }

    &:active {
      transform: translateY(0);
    }
  }

  // 默认按钮（取消/关闭）样式优化
  ::v-deep .el-button--default {
    border-color: #dcdfe6;
    color: #606266;

    &:hover {
      color: #1366ec;
      border-color: #1366ec;
      box-shadow: 0 4px 12px rgba(19, 102, 236, 0.15);
    }
  }
}

.el-table {
  border: 1px solid #dfdfdf !important;
  margin: 0 auto;
}
::v-deep .el-table th {
  border: 1px solid #dfdfdf !important;
}

::v-deep .el-table td {
  border: 1px solid #dfdfdf !important;
}

/* ===== 内联详情模式 ===== */
.detail-page {
  padding:0 0 20px 0;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 20px;
  background: #1366ec;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.85;
  }
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
}

.title-bar {
  width: 4px;
  height: 18px;
  background: #1366ec;
  border-radius: 2px;
}

.info-grid {
  display: grid;
  gap: 16px 40px;
}

.info-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.info-row {
  display: flex;
  // flex-direction: column;
  gap: 6px;
}

.info-label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
}

.info-value {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  word-break: break-all;
  margin-left: 30px;
}

/* 进度条 */
.progress-card {
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.progress-steps {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 10px;
}

.progress-step {
  display: flex;
  flex-direction: column;
  //align-items: center;
  flex: 1;
  position: relative;
}

.step-line-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.step-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 1;
  transition: all 0.3s;

  i {
    font-size: 12px;
    color: #fff;
  }

  &.done {
    background: #1366ec;
  }

  &.current {
    background: #1366ec;
    box-shadow: 0 0 0 4px rgba(19, 102, 236, 0.2);
  }
}

.step-line {
  flex: 1;
  height: 3px;
  background: #e8e8e8;
  transition: background 0.3s;

  &.done {
    background: #1366ec;
  }
}

.step-label {
  margin-top: 10px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  transition: color 0.3s;

  &.done {
    color: #1366ec;
    font-weight: 500;
  }

  &.current {
    color: #1366ec;
    font-weight: 600;
  }
}
</style>
